let language = {
    STORE_PRODUCT_LIST_SEARCH_PLACEHOLDER: "搜索",
    STORE_PRODUCT_LIST_SYNCHRONOUS_BTN: "同步",
    STORE_PRODUCT_LIST_SYNC_BTN: "同步",
    STORE_PRODUCT_LIST_REMOVE_BTN: "移除",
    STORE_PRODUCT_LIST_COPY_BTN: "复制",
    STORE_PRODUCT_LIST_ADD_BTN: "添加",
    STORE_PRODUCT_LIST_EDIT_BTN: "编辑",
    STORE_PRODUCT_LIST_EDIT_PHOTO_LIB_BTN: "编辑素材库",
    STORE_PRODUCT_LIST_SAMPLE_ORDER_BTN:"样品单",
    STORE_PRODUCT_LIST_EDIT_PRICE_BTN: "编辑价格",
    STORE_PRODUCT_LIST_EDIT_INFO_BTN: "编辑产品信息",
    STORE_PRODUCT_LIST_EDIT_DESIGN_BTN: "编辑设计",
    STORE_PRODUCT_LIST_RESOURCE_SETTING: "库设置",
    STORE_PRODUCT_LIST_SEARCH_EMPTY_DES1: "要找到您正在搜索的商店产品，您可以点击",
    STORE_PRODUCT_LIST_SEARCH_EMPTY_DES2: "这里",
    STORE_PRODUCT_LIST_SEARCH_EMPTY_DES3: "查看我们的目录并选择您想要提供给客户的产品。",
    STORE_PRODUCT_LIST_HEAD_PRODUCT: "产品",
    STORE_PRODUCT_LIST_HEAD_PRODUCT_STATUE: "产品状态",
    STORE_PRODUCT_LIST_HEAD_SYNC_STATUE: "同步状态",
    STORE_PRODUCT_LIST_HEAD_ACTIONS: "操作",
    STORE_PRODUCT_LIST_FULL_PRODUCT_PROPERTY: "完整产品",
    STORE_PRODUCT_LIST_PRODUCT_SYNCING: "同步中",
    STORE_PRODUCT_LIST_PRODUCT_SYNC_FAILED: "同步失败",
    STORE_PRODUCT_LIST_PRODUCT_SYNC_SUCCESS: "同步成功",
    STORE_PRODUCT_LIST_PRODUCT_NO_SYNC: "未同步",
    STORE_PRODUCT_LIST_PRODUCT_ACTIVE: "激活",
    STORE_PRODUCT_LIST_PRODUCT_INACTIVE: "未激活",
    STORE_PRODUCT_LIST_PRODUCT_ACTIVE_BTN: "激活",
    STORE_PRODUCT_LIST_PRODUCT_DEACTIVATE_BTN: "取消激活",
    STORE_PRODUCT_LIST_PRODUCT_IMAGE_ERROR_TIP: "您的产品缩略图加载失败，您可以点击重新加载图片。"
};

export { language }
